<template>
    <div class="card-box p-0" v-pml-block="isLoading">
        <div class="p-10">
            <div class="row">
                <div class="col-xs-12">
                    <h4 class="header-title m-t-10 m-b-5 text-dark t_sm_center">{{ $t('open_deals') }}</h4>
                </div>
            </div>
        </div>
        <div class="over_auto">
            <table class="table table-striped table-bordered m-0 label_block">
                <thead>
                    <tr>
                        <th class="min_w_180" rowspan="2">{{ $t('consultant') }}</th>
                        <th class="t_center" rowspan="2">{{ $t('total') }}</th>
                        <th class="t_center" rowspan="2">{{ $t('no_quotation') }}</th>
                        <th class="t_center" colspan="5">{{ $t('in_quotation_stage') }}</th>
                    </tr>
                    <tr>
                        <th class="t_center">{{ $t('new') }}</th>
                        <th class="t_center">{{ $t('pending') }}</th>
                        <th class="t_center">{{ $t('refused') }}</th>
                        <th class="t_center">{{ $t('sent') }}</th>
                        <th class="t_center">{{ $t('approved') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="m in membersIds">
                        <td class="bold">{{ m | pmlMemberById }}</td>
                        <td class="t_center">{{ getAmount('total', m) }}</td>
                        <td class="t_center">{{ getAmount('unquoted', m) }}</td>
                        <td class="t_center">{{ getAmount('new', m) }}</td>
                        <td class="t_center">{{ getAmount('pending', m) }}</td>
                        <td class="t_center">{{ getAmount('refused', m) }}</td>
                        <td class="t_center">{{ getAmount('sent', m) }}</td>
                        <td class="t_center">{{ getAmount('approved', m) }}</td>
                    </tr>
                    <tr v-if="!membersIds.length">
                        <td class="t_center" colspan="30"><i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { map, uniq, find } from 'lodash'

    export default {
        name: 'ByConsultant',
        props: {
            'isLoading': {
                type: Boolean,
                required: true,
                default: false
            },
            'tableData': {
                type: Object | Boolean,
                required: true
            }
        },
        computed: {
            ...mapGetters({
                'members': 'getMembers'
            }),
            membersIds () {
                return uniq(map(this.tableData.total, 'member_id')) || []
            }
        },
        methods: {
            getAmount (type, memberId) {
                const obj = find(this.tableData[type], { 'member_id': parseInt(memberId) })
                return obj ? obj.amount : 0
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/reports/deals/components/ByConsultant.vue